// Header and data rows must line up, so the track list is shared rather than
// repeated in two files (same reason as negative-reviews/qaTable.ts).
export const PROACTIVE_TABLE_COLUMNS =
  "grid grid-cols-[130px_92px_minmax(150px,1fr)_minmax(140px,1fr)_minmax(240px,2fr)_minmax(150px,1.1fr)_64px] items-center gap-3";
